














































































































import settings from '@/settings'
import n from '@/utils/notifications'
import t from '@/utils/tools'
import q from '@/graphql/query'
import m from '@/graphql/mutation'
import af from '@/utils/authorized_formats'
import FileUpload from '@/components/file_upload'

export default {
    name: 'users_graduates'
    components: {
        FileUpload
    }
    props: {
        uid: {
            type: String
        }
    }
    data: ()->
        false: false
        true: true
        pager_count: 5
        current_page: 1
        page_size: 10
        search: ''
        loading: true
        alert: false
        errors: {}
        active_names: [1]
        graduate_level_choice_set: @$store.state.graduate_level_choice_set
        graduate_type_choice_set: []
        precision: 0
        clearable: true
        picker_options: {firstDayOfWeek:1}
        max_filesize: af['graduate']['file']['max_filesize']/1024/1024
        authorized_formats: af['graduate']['file']['authorized_formats']
        graduate: {
            uid: ''
            user_uid: @uid
            name: ''
            validated: true
            obtainment_str: ''
            validity_duration: '0'
            validity_end: ''
            level: {uid:''}
            graduate_type: {uid:''}
            file_name: ''
            file_data: ''
            file: ''
            file_dir: ''
        }
        graduates: []

    computed:
        data_filtered: ()->
            self = @
            data = @graduates.filter (x)->
                validity_end = false
                validated = 'non'
                if x.validated
                    validated = 'oui'
                if x.validity_end?
                    validity_end = x.validity_end.toString().toLowerCase().includes(self.search.toLowerCase())
                !self.search \
                || x.name.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search.toLowerCase()) || x.name.toLowerCase().includes(self.search.toLowerCase())\
                || x.obtainment_str.includes(self.search.toLowerCase()) \
                || validity_end \
                || validated.includes(self.search.toLowerCase()) \
                || x.level.label.toLowerCase().includes(self.search.toLowerCase()) \
                || x.graduate_type.label.toLowerCase().includes(self.search.toLowerCase())
            return data

        data_paged: ()->
            data = @data_filtered.slice(((@current_page - 1) * @page_size), (@page_size * @current_page))
            return data

        save_text: ()->
            text = "Ajouter"
            if @graduate.uid != ''
                text = "Enregistrer"
            return text

        toggle_collapse_text: ()->
            text = "Ajouter une qualification"
            if @active_names.length > 1
                text = "Fermer"
            return text

        toggle_collapse_icon: ()->
            class_icon = 'mdi-plus-circle-o'
            if @active_names.length > 1
                class_icon = 'mdi-close-circle-o'
            return class_icon

        has_mutation_right: ()->
            return @has_access_right(@get_access('edit'))

        has_deletion_right: ()->
            return @has_access_right(@get_access('delete'))

    methods:
        has_access_right: t.has_access_right

        download_file: (graduate)->
            url = settings.media_url+graduate.file_dir+'/'+graduate.file
            filename = graduate.complete_filename
            t.download_file(url, filename)
            return
            
        reset_graduate: ()->
            @graduate = {
                uid: ''
                user_uid: @uid
                name: ''
                validated: true
                obtainment_str: ''
                validity_duration: '0'
                validity_end: ''
                level: t.deep_copy(@graduate_level_choice_set[0])
                graduate_type: {uid:''}
                file_name: ''
                file_data: ''
                file: ''
                file_dir: ''
            }
            return

        listen_sort: ({ column, prop, order })->
            # console.log "LISTEN", column, prop, order
            self = @
            @graduates.sort (a,b)->
                field_a = field_b = ""
                if prop == 'validity_duration'
                    if a[prop] != null
                        field_a = a[prop].toString()
                    if b[prop] != null
                        field_b = b[prop].toString()
                else if prop == 'level.label'
                    props = prop.split('.')
                    field_a = a[props[0]][props[1]]
                    field_b = b[props[0]][props[1]]
                else if prop == 'graduate_type.label'
                    props = prop.split('.')
                    if a[props[0]] != null
                        field_a = a[props[0]][props[1]]
                    if b[props[0]] != null
                        field_b = b[props[0]][props[1]]
                else if prop == 'validated'
                    field_a = 'non'
                    field_b = 'non'
                    if a[prop]
                        field_a = 'oui'
                    if b[prop]
                        field_b = 'oui'
                else
                    if a[prop] != null
                        field_a = a[prop]
                    if b[prop] != null
                        field_b = b[prop]
                modifier = 1
                if order == 'descending'
                    modifier = -1
                return field_a.toLowerCase().localeCompare(field_b.toLowerCase())*modifier

        handle_size_change: (val)->
            @page_size = val

        handle_current_change: (val)->
            @current_page = val

        get_errors: (fieldName)->
            ret = null
            if @errors[fieldName]?
                ret = @errors[fieldName][0]
            return ret

        collapse_change: (value)->
            # console.log "VUE TOGGLE ", value
            @errors = {}
            @reset_graduate()
            #if @$refs.file_upload?
            #    @$refs.file_upload.clearFiles()
            return

        handle_tmp_file_remove: (file, fileList)->
            #@$refs.file_upload.clearFiles()
            @graduate.file_data = ''
            @graduate.file_name = ''
            return

        handle_file_remove: ()->
            @graduate.file = ''
            @graduate.file_dir = ''
            return

        handle_file_change: (file, fileList)->
            is_good_ext = file.raw.type in af['graduate']['file']['mime_types']
            is_good_size = file.size < af['graduate']['file']['max_filesize']

            if !is_good_ext
                n.file_error('Erreur', 'Le fichier doit être de type '+@authorized_formats+'.')
                fileList.pop()
                return
            if !is_good_size
                n.file_error('Erreur', 'Le fichier ne peut pas excéder '+@max_filesize+'Mo.')
                fileList.pop()
                return

            self = @
            if fileList.length > 1
                fileList.splice(0,1)
            reader = new FileReader()
            reader.onload = (e)->
                # console.log 'E', e
                self.graduate.file_data = e.target.result
                self.graduate.file_name = file.name
            reader.readAsDataURL(file.raw)
            # console.log "FILE", @graduate
            return

        edit_graduate: (index)->
            @graduate = t.deep_copy(@graduates[index])
            if @graduate.graduate_type is null
                @graduate.graduate_type = {uid:''}
            @active_names = [1, "1"]
            @$root.$el.scrollTop = 0
            @errors = {}
            return

        get_access: (suffix)->
            access = "graduates_self_"+suffix
            if @$route.name == 'company_users_graduates'
                access = "graduates_"+suffix
            return access

        delete_graduate: (graduate_uid)->
            # console.log  "DELETE GRADUATE", graduate_uid
            self = @
            @$confirm("Êtes-vous sûr·e de vouloir supprimer cette qualification ?", 'Confirmation', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler'
                })
                .then ()->
                    # console.log "GRADUATE DELETE", graduate_uid
                    m.run('delete_object', ['graduate', graduate_uid])
                    .then (resp)->
                        # console.log "DELETE GRADUATE", resp.body.data.object_deletion
                        if resp.body.data.graduate_deletion.ok
                            n.success()
                            self.get_graduates()
                        else
                            n.gql_error("users_graduates: delete_graduate: then", resp.body.data.graduate_deletion.message)
                    .catch (resp)->
                        n.catch_error(resp, "users_graduates: delete_graduate()")
                .catch (cancel)->
                    return

        save: ()->
            # console.log "SAVE GRADUATE", @graduate
            self = @
            @graduate.user_uid = @uid
            m.run('save_graduate', [@graduate])
            .then (resp)->
                if resp.body.data.graduate_form_mutation.form_ret == 'failed'
                    return n.access_denied()
                if resp.body.data.graduate_form_mutation.errors.length > 0
                    # console.log "ERRORS", resp.body.data.graduate_form_mutation.errors
                    self.errors = resp.body.data.graduate_form_mutation.errors.reduce(
                        (acc, el)->
                            acc[el.field] = el.messages
                            return acc
                    ,{})
                    n.form_error()
                else
                    self.errors = {}
                    await self.$refs.file_upload.save_from_parent(
                      resp.body.data.graduate_form_mutation.form_ret)                    
                    n.success()
                    self.reset_graduate()
                    #if self.$refs.file_upload?
                    #    self.$refs.file_upload.clearFiles()
                    self.active_names = [1]
                    self.get_graduates()
            .catch (resp)->
                n.catch_error(resp, "users_graduates: save()")

        get_graduate_type_choice_set: ()->
            self = @
            @errors = {}
            q.run('get_type_set', ['graduate_choice'])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("users_graduates: get_graduate_type_choice_set: then" ,e.message)
                else
                    # console.log "GET GRADUATE TYPE CHOICE SET : ", resp.body.data.graduate_choice_set
                    self.graduate_type_choice_set = resp.body.data.graduate_choice_set
            .catch (resp)->
                n.catch_error(resp, "users_graduates: get_graduate_type_choice_set()")

        get_graduates: ()->
            self = @
            @loading = true
            q.run('get_graduate_set', [@uid])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("users_graduates: get_graduates: then", e.message)
                else
                    # console.log "GET GRADUATES : ", resp.body.data.graduate_set
                    self.graduates = resp.body.data.graduate_set
                    self.loading = false
                    if self.graduates.length == 0
                        self.alert = true
                    else
                        self.alert = false
            .catch (resp)->
                n.catch_error(resp, "users_graduates: get_graduates()")

    beforeMount: ()->
        @get_graduate_type_choice_set()
        if @uid != '0'
            @get_graduates()
}
